import React from "react";
import { DataTable } from "react-native-paper";
import { TableValueCellComponent } from "./Types";

export const TableMechanicSelectionCell: TableValueCellComponent = ({
  field,
  value,
}) => {
  return (
    <DataTable.Cell>
      {Array.isArray(value) &&
        value
          .map((v) => {
            if (v.relatedObjectField) {
              return v.relatedObjectField?.map(
                (ro: { [x: string]: any }) => ro[field?.relatedObject.key],
              );
            }

            return JSON.stringify(v[field.key]);
          })
          .join(", ")}
    </DataTable.Cell>
  );
};
